import { render } from "./CardCorner.vue?vue&type=template&id=130d8ffa&scoped=true"
import script from "./CardCorner.vue?vue&type=script&lang=js"
export * from "./CardCorner.vue?vue&type=script&lang=js"

import "./CardCorner.vue?vue&type=style&index=0&id=130d8ffa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130d8ffa"]])

export default __exports__